<template>
  <span>
    <modal @close="$emit('close')">
      <h4 slot="title">{{ $t('removeLocation') }}</h4>
      <section class="modal-confirm-action" slot="body">
        <p class="confirmation">
          {{ $t('removeLocationAreYouSure', { location: location.name }) }}
        </p>
        <p class="warning">
          {{ $t('thisCannotBeUndone') }}
        </p>
        <div class="buttons">
          <button id="delete-button" class="clavo-button clavo-button-danger-primary" @click="removeLocation">
            {{ $t('remove') }}
          </button>
          <button id="cancel-button" class="clavo-button secondary" @click="$emit('close')">
            {{ $t('cancel') }}
          </button>
        </div>
      </section>
    </modal>
  </span>
</template>

<script>
import Modal from '@/components/Modal'
import Constants from '@/components/Constants'
import ParseFunctions from '@/components/ParseFunctions'

export default {
  components: {
    Modal,
  },
  mixins: [Constants, ParseFunctions],
  props: {
    location: Object,
  },
  methods: {
    async removeLocation() {
      let res = await this.deleteLocation(this.location.objectId)
      if (res.status === 'ok') {
        this.$emit('location-removed')
        this.$emit('close')
      } else {
        this.showServerError(res)
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
